// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__Vuwkw","Card__title":"Card_Card__title__Dl4Rj","Card__data":"Card_Card__data__B3jXR"};